/**
 * 创作者平台登录/注册链接、官网首页链接。
 * 按 host 判断：localhost / 创作者域用相对路径；官网域用绝对创作者 URL（部署时配置 NEXT_PUBLIC_CREATOR_PLATFORM_URL）。
 */
import { DEFAULT_MARKETING_ORIGIN } from '@/lib/seoConfig';

const CREATOR_BASE = process.env.NEXT_PUBLIC_CREATOR_PLATFORM_URL?.replace(/\/$/, '') ?? '';
const BRAND_HOME = process.env.NEXT_PUBLIC_BRAND_SITE_URL?.replace(/\/$/, '') || DEFAULT_MARKETING_ORIGIN;

function getCreatorAbsoluteBase(): string {
  if (typeof window === 'undefined') return CREATOR_BASE;
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') return '';
  if (!CREATOR_BASE) return '';
  try {
    if (new URL(CREATOR_BASE).hostname === host) return '';
    return CREATOR_BASE;
  } catch {
    return '';
  }
}

function isCreatorHost(): boolean {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') return false;
  if (!CREATOR_BASE) return false;
  try {
    return new URL(CREATOR_BASE).hostname === host;
  } catch {
    return false;
  }
}

/** 官网首页 URL：创作者域下为绝对 URL，否则为相对路径 / */
export function getBrandHomeUrl(): string {
  return isCreatorHost() ? BRAND_HOME : '/';
}

/** 官网关于页 URL */
export function getBrandAboutUrl(): string {
  const home = getBrandHomeUrl();
  return home === '/' ? '/about' : `${home}/about`;
}

/** 官网投资者平台页 URL */
export function getBrandInvestorsUrl(): string {
  const home = getBrandHomeUrl();
  return home === '/' ? '/investors' : `${home}/investors`;
}

/** 官网联系我们页 URL */
export function getBrandContactUrl(): string {
  const home = getBrandHomeUrl();
  return home === '/' ? '/contact' : `${home}/contact`;
}

/** 官网创始团队页 URL */
export function getBrandTeamUrl(): string {
  const home = getBrandHomeUrl();
  return home === '/' ? '/team' : `${home}/team`;
}

/** 官网加入我们页 URL */
export function getBrandCareersUrl(): string {
  const home = getBrandHomeUrl();
  return home === '/' ? '/careers' : `${home}/careers`;
}

export function getCreatorLoginUrl(): string {
  const base = getCreatorAbsoluteBase();
  return base ? `${base}/login` : '/login';
}

export function getCreatorRegisterUrl(): string {
  const base = getCreatorAbsoluteBase();
  return base ? `${base}/register` : '/register';
}
